<template>
  <v-container
    id="data-tables"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers.filter(a=>a.show || a.active)"
              :footer-props="datatableFooter"
              no-data-text="Нет данных для отображения"
              :options.sync="tableOptions"
              :items="items"
              :server-items-length="total"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col
                        cols="12"
                        sm="2"
                      >
                        <v-text-field
                          v-model="form.search"
                          clearable
                          outlined
                          label="Поиск"
                          prepend-inner-icon="mdi-magnify"
                          dense
                          @keyup.enter="onLoad"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="3"
                      >
                        <v-btn
                          color="primary"
                          outlined
                          @click="onShowFilterDialog"
                        >
                          <v-icon class="ml-3">
                            mdi-filter-variant
                          </v-icon>
                          <span class="mx-3">ФИЛЬТРЫ</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="3"
                        class="d-sm-flex justify-end"
                        md="2"
                        offset-md="2"
                        offset-xl="4"
                        xl="1"
                      >
                        <v-btn
                          v-if="$store.state.access[15][5]"
                          color="primary"

                          @click="$router.push('/admin/inventory/create')"
                        >
                          <v-icon class="ml-3">
                            mdi-plus
                          </v-icon>
                          <span class="mx-3">Добавить</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="3"
                        class="d-sm-flex justify-end"
                        md="2"
                        xl="1"
                      >
                        <v-btn
                          v-if="$store.state.access[15][5]"
                          color="secondary"
                          outlined
                          @click="onReport"
                        >
                          <v-icon class="ml-3">
                            mdi-download
                          </v-icon>
                          <span class="mx-3">Выгрузить</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="1"
                        class="d-sm-flex justify-center"
                      >
                        <v-icon
                          medium
                          class="icon-table"
                          @click="onShowHeadersDialog"
                        >
                          mdi-table-cog
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="12"
                        class="mt-n5"
                      >
                        <div v-if="filter.set">
                          <div
                            v-for="(tab, index) in filterFields"
                            :key="'tab_f' + index"
                          >
                            <v-chip
                              v-for="(filter, index2) in tab.data.filter(a=>a.value ||a.value ===0 || a.from || a.to || a.max || a.min)"
                              :key="'data_f' + index2"
                              color="grey lighten-2"
                              class="ma-1"
                              close
                              @click:close="onClearFilterValue(filter)"
                            >
                              <span v-if="filter.type == 'date'">{{ filter.name }}: {{ format(filter.from) }}/{{ format(filter.to) }}</span>
                              <span v-else-if="filter.type == 'select' || filter.type == 'autocomplete'">{{ filter.name }}: {{ filter.select.filter(a=>a.value == filter.value)[0].text }}</span>
                              <span v-else>{{ filter.name }}: {{ filter.value }}</span>
                            </v-chip>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <!--                    <v-row dense>-->
                    <!--                      <v-col cols="2">-->
                    <!--                        <v-checkbox-->
                    <!--                          v-model="show_deleted_point"-->
                    <!--                          label="Показать удалённые"-->
                    <!--                          @change="onChangeConf"-->
                    <!--                        />-->
                    <!--                      </v-col>-->
                    <!--                    </v-row>-->
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="100"
                  :nudge-bottom="12"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs, value }">
                    <v-btn
                      v-bind="attrs"
                      color="primary"
                      text
                      v-on="on"
                      @click="sheetitem = item"
                    >
                      <v-icon
                        large
                        class="beg_triangle"
                      >
                        mdi-menu-open
                      </v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-list>
                      <v-list-item
                        v-if="!sheetitem.deleted"
                        @click="$router.push('/admin/inventory/view?id=' + sheetitem.id)"
                      >
                        <v-list-item-content>
                          Открыть
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="!sheetitem.deleted && ($store.state.access[15][3] || $store.state.access[15][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id)"
                        @click="$router.push('/admin/inventory/change?id=' + sheetitem.id)"
                      >
                        <v-list-item-content>
                          Изменить
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="!sheetitem.deleted && ($store.state.access[15][3] || $store.state.access[15][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id)"
                        @click="onDelete(sheetitem)"
                      >
                        <v-list-item-content>
                          Удалить
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="sheetitem.deleted && ($store.state.access[15][3] || $store.state.access[15][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id)"
                        @click="onRestore(sheetitem)"
                      >
                        <v-list-item-content>
                          Восстановить
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </template>
              <template v-slot:item.created="{ item }">
                {{ formatDateTime(item.created) }}
              </template>
              <template v-slot:item.pointId="{ item }">
                <span v-if="item.pointId">
                  {{ points.find(f=>f.value === item.pointId).text
                  }}
                </span>
              </template>
              <template v-slot:item.status="{ item }">
                <span v-if="item.status>0">
                  {{ DocumentStatusArray().find(f=>f.value === item.status).text }}
                </span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <justpay-header-dialog
        :dialog-headers="headers.filter(f=>!f.show)"
        :dialog-visible="dialog.header.show"
        @close="dialog.header.show=false"
        @header="onSetHeader($event)"
      />
      <justpay-filter-dialog
        :dialog-visible="dialog.filter.show"
        :filter-fields="filterFields"
        @close="dialog.filter.show=false"
        @change="onSetFilter($event)"
      />
    </v-row>
  </v-container>
</template>
<script>
import { JustpayInventoryService } from "@/views/loyalty/shared/services/justpay-inventory-service"
import moment from "moment/moment"
import { DocumentStatusArray } from "@/views/loyalty/models/justpay-inventory.model"
import { downloadCsvFile } from "@/views/loyalty/shared/modules/utilities"
import JustpayHeaderDialog from "@/views/loyalty/shared/components/header/JustpayHeaderDialog.vue"
import JustpayFilterDialog from "@/views/loyalty/shared/components/filter/JustpayFilterDialog.vue"

export default {
  name: 'InventoryList',
  components: { JustpayFilterDialog, JustpayHeaderDialog },
  data: () => ({
    datatableFooter: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    dialog: {
      header: {
        show: false
      },
      filter: {
        show: false
      }
    },
    entity: 'admin.inventory',
    filter: {
      set: false
    },
    filterFields: {
      common: {
        index: 0,
        name: 'Основное',
        active: true,
        data: [
          {
            name: 'Дата создания',
            data: 'created',
            type: 'date',
          },
          {
            name: 'Номер',
            data: 'number',
            type: 'text',
          },
          {
            name: 'Точка',
            data: 'pointId',
            type: 'autocomplete',
            select: []
          },
        ]
      }
    },
    form: {},
    headers: [
      {
        text: 'Действия',
        value: 'actions',
        show: true
      },
      {
        text: 'Дата создания',
        value: 'created',
        active: true,
        active_temp: true
      },
      {
        text: 'Номер',
        value: 'number',
        active: true,
        active_temp: true
      },
      {
        text: 'Точка',
        value: 'pointId',
        active: true,
        active_temp: true
      },
      {
        text: 'Комиссия',
        value: 'commission',
        active: true,
        active_temp: true
      },
      {
        text: 'Статус',
        value: 'status',
        active: true,
        active_temp: true
      },
      {
        text: 'Результат',
        value: 'result',
        active: true,
        active_temp: true
      },
    ],
    justpayInventoryService: null,
    items: [],
    loading: false,
    points: [],
    sheetitem: {},
    tableOptions: {},
    total: 0
  }),
  watch: {
    tableOptions: {
      async handler () {
        // console.log(this.tableOptions)
        this.$router.push({
          query: {
            page: this.tableOptions.page,
            limit: this.tableOptions.itemsPerPage
          }
        })
        await this.load()
      },
      deep: true,
    },
  },
  beforeMount () {
    this.justpayInventoryService = new JustpayInventoryService()
    this.setDefaultHeaders()
  },
  async mounted () {
    await this.load()
  },
  methods: {
    DocumentStatusArray () {
      return DocumentStatusArray
    },
    format: function (date) {
      return moment(date).format('DD.MM.YYYY')
    },
    formatDateTime: function (date) {
      return moment(date).format('DD.MM.YYYY HH:mm:ss')
    },
    async load () {
      const request = JSON.parse(JSON.stringify(this.form))
      console.log('request', request)
      if (this.filter.set) {
        request.data = JSON.parse(JSON.stringify(this.filterFields))
        delete request.data.set
        delete request.data.changed
      }
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions
      request.page = page
      request.limit = itemsPerPage
      // request.all = this.show_deleted_point
      const response = await this.justpayInventoryService.getInventories(request)
      if (!response.error) {
        this.items = response.data
        this.total = response.count
        this.points = response.points
        this.filterFields.common.data.map(item => {
          if (item.data === 'pointId') {
            item.select = [...response.points]
            return item
          }
        })
      }
      this.loading = false
    },
    onClearFilterValue (field) {
      field.value = ''
      field.from = ''
      field.to = ''
      field.date_select = ''
      field.min = ''
      field.max = ''
      this.filter.changed = true
      this.setFilter()
    },
    onDelete (sheetitem) {
      //
    },
    onLoad () {
      //
    },
    async onReport () {
      const request = JSON.parse(JSON.stringify(this.form))
      if (this.filter.set) {
        request.data = JSON.parse(JSON.stringify(this.filterFields))
        delete request.data.set
        delete request.data.changed
      }
      request.headers = this.headers.filter(a => a.active === true).map(a => a.value)
      const data = await this.justpayInventoryService.downloadData(request)
      console.log('onReport data', data)
      downloadCsvFile("inventory.csv", data.join(""))
    },
    onRestore (sheetitem) {
      //
    },
    async onSetFilter (filters) {
      console.log('filters', filters)
      this.filter.set = true
      await this.load()
      localStorage.setItem(this.entity, JSON.stringify(this.filterFields))
      this.dialog.filter.show = false
    },
    onSetHeader (headers) {
      console.log('headers', headers)
      for (const x in headers) {
        this.headers[x].active = headers[x].active_temp
        this.headers[x].active_temp = headers[x].active_temp
      }
      this.dialog.header.show = false
    },
    onShowFilterDialog () {
      this.dialog.filter.show = true
    },
    onShowHeadersDialog () {
      this.dialog.header.show = true
    },
    setDefaultHeaders () {
      if (!this.$store.state.user.inventoryHeaders || this.$store.state.user.inventoryHeaders.length === 0) return
      this.headers = this.headers.map(header => {
        header.active = this.$store.state.user.inventoryHeaders.indexOf(header.value) > -1
        return header
      })
    },
    setFilter: function (flag) {
      if (this.filter.changed) this.filter.set = true
      this.filter.changed = false
      this.load()
      localStorage.setItem(this.entity, JSON.stringify(this.filterFields))
    },
  }
}
</script>

<style scoped>

</style>
